export default "__VITE_ASSET__CdxSCyXW__"